var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsUUIDWithLVS } from '@goparrot/common';
import { ApiExtraModels, ApiProperty } from '@nestjs/swagger-v4';
import { Expose, Type } from 'class-transformer';
import { IsNotEmpty, ValidateNested } from 'class-validator';
import { CohortTemplateExposeGroup } from '../interface';
import { ReadCohortTemplateFeaturePayloadDto } from './ReadCohortTemplateFeaturePayloadDto';
let ReadCohortTemplateFeatureReferenceDto = class ReadCohortTemplateFeatureReferenceDto {
};
__decorate([
    ApiProperty({ type: () => String, format: 'uuid', description: 'uuid v4 ref to Feature.uid', example: '543e8947-2d15-4436-b9df-915fddf1ccf3' }),
    Expose({
        groups: [CohortTemplateExposeGroup.FIXTURE, CohortTemplateExposeGroup.READ, CohortTemplateExposeGroup.CREATE, CohortTemplateExposeGroup.UPDATE],
    }),
    IsNotEmpty({ always: true }),
    IsUUIDWithLVS('4', { always: true }),
    __metadata("design:type", String)
], ReadCohortTemplateFeatureReferenceDto.prototype, "featureId", void 0);
__decorate([
    ApiProperty({ type: () => ReadCohortTemplateFeaturePayloadDto }),
    Expose({
        groups: [CohortTemplateExposeGroup.FIXTURE, CohortTemplateExposeGroup.READ, CohortTemplateExposeGroup.CREATE, CohortTemplateExposeGroup.UPDATE],
    }),
    Type(() => ReadCohortTemplateFeaturePayloadDto),
    ValidateNested({ always: true }),
    __metadata("design:type", ReadCohortTemplateFeaturePayloadDto)
], ReadCohortTemplateFeatureReferenceDto.prototype, "payload", void 0);
ReadCohortTemplateFeatureReferenceDto = __decorate([
    ApiExtraModels(ReadCohortTemplateFeaturePayloadDto)
], ReadCohortTemplateFeatureReferenceDto);
export { ReadCohortTemplateFeatureReferenceDto };
//# sourceMappingURL=ReadCohortTemplateFeatureReferenceDto.js.map